import { parse } from 'qs';
import { ClassAttributes, createElement } from 'react';
import { RouteComponentProps } from 'react-router';

import RouteLifecycleWrapper from '../component/primitive/RouteLifecycleWrapper';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as HistoryConsumer } from '../context/history';
import { Consumer as StateConsumer } from '../context/state';
import _OffersDetailPage from '../page/OfferDetailPage';

type UrlParams = {
  offerId: string;
};

type Props = ClassAttributes<HTMLElement> & RouteComponentProps<UrlParams>;

const OfferDetailPage = ({ match }: Props) => (
  <DependencyConsumer>
    {(dependency) => (
      <HistoryConsumer>
        {(_history) => (
          <StateConsumer>
            {(state) => (
              <RouteLifecycleWrapper
                onMount={async () => {
                  dependency.authenticationUsecase.needSignedIn();
                  await dependency.showOfferUsecase.prepare(match.params.offerId);
                }}
                onUnmount={() => dependency.showOfferUsecase.disposeOffer()}
              >
                <_OffersDetailPage
                  offer={state.offer.offer}
                  project={state.project.project}
                  hasProjectChange={state.project.project?.hasChanges || false}
                  assetFiles={state.offer.assetFiles}
                  briefFiles={state.offer.briefFiles}
                  loading={state.offer.fetching >= 1}
                  mutating={state.offer.mutating >= 1}
                  defaultTab={parse(state.location.search.slice(1)).defaultTab}
                  signedInUser={state.authentication.signedInUser!}
                  applyForOffer={(offerId: string) => dependency.offerApplicationUsecase.applyForOffer(offerId)}
                />
              </RouteLifecycleWrapper>
            )}
          </StateConsumer>
        )}
      </HistoryConsumer>
    )}
  </DependencyConsumer>
);

export default OfferDetailPage;
